import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "21",
  viewBox: "0 0 22 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "M2.63 3.392c0-.583.473-1.055 1.056-1.055h14.627c.583 0 1.055.472 1.055 1.055v14.556c0 .583-.472 1.055-1.055 1.055H3.686a1.056 1.056 0 0 1-1.055-1.055V3.392z",
      stroke: "currentColor",
      "stroke-width": "1.056"
    }, null, -1),
    _createElementVNode("path", {
      d: "M5.186 11.335h1.3v1.673c0 .15.123.273.274.273h1.026v.328c0 .15.122.273.274.273h1.673v1.165h-1.42a.273.273 0 1 0 0 .546h6.85a.273.273 0 1 0 0-.546h-1.42v-1.165h1.165c.04.103.138.176.255.176h1.325c.498 0 .69-.72.79-1.263.114-.619.177-1.448.177-2.336 0-1.344-.125-3.6-.966-3.6h-1.326a.272.272 0 0 0-.255.177H8.06a.273.273 0 0 0-.274.273v.328H6.76a.273.273 0 0 0-.274.273v1.673h-1.3a.878.878 0 0 0-.881.875.88.88 0 0 0 .88.877zm10.25-3.93h1.028c.19.16.444 1.286.444 3.054 0 1.768-.254 2.893-.444 3.054h-1.027V7.405zm-2.24 7.642H10.28v-1.165h2.914v1.165zM9.632 7.582h5.256v5.754H9.633V7.582zm-1.3 5.426V7.582h.752v5.754h-.751v-.328zm-1.299-1.946v-2.88h.752v4.553h-.752v-1.673zm-2.085-.837a.336.336 0 0 1 .237-.097h1.3v.662h-1.3a.333.333 0 0 1-.333-.332c0-.087.035-.17.096-.233z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10.403 8.951h3.714a.273.273 0 1 0 0-.545h-3.714a.273.273 0 1 0 0 .545zM10.403 10.138h3.714a.273.273 0 1 0 0-.546h-3.714a.273.273 0 1 0 0 .546zM10.403 11.325h3.714a.273.273 0 1 0 0-.546h-3.714a.273.273 0 1 0 0 .546zM10.403 12.512h3.714a.273.273 0 1 0 0-.545h-3.714a.273.273 0 1 0 0 .545z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }